export class WageTranslateModel {
    description = {
        en: '',
        de: '',
        fr: '',
        it: '',
    };
}